import React, { Component } from "react";
import { Row, Col, Input, Table, Drawer, Button, Upload, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { withRouter } from "react-router-dom";
import "./VendorList.css";
import SendMainIcon from "../../svg/svgicon/SendMailIcon";
import ButtonLinkIcon from "../../Components/MyComponent/ButtonLinkIcon";
import FilterIcon from "../../svg/svgicon/FilterIcon";
import { API } from "../../API/API";
import { baseConfig } from "../../Config/Config";
import VendorInfo from "./VendorInfo";
import getBase64 from "../../Components/ConvertBase64/getBase64";
class VendorList extends Component {
  state = {
    data: [],
    sendButtonText: "И-мэйл илгээх (0)",
    selectedRowKeys: [],
    selectedVendors: [],
    subject: "",
    body: "",
    filename: "",
    filedata: null,
    filelist: [],
    selectedVendorId: 0,
  };
  componentDidMount = () => {
    this.getData();
  };
  getData = () => {
    API.get("getVendors").then((response) => {
      if (response.status === 200) {
        this.setState({ data: response.data.retData });
      }
    });
  };
  showNewInputFormHandler = (show, vendorid) => {
    this.setState({
      showNewInputForm: show,
      selectedVendorId: vendorid,
    });
  };
  onSelectChange = (selectedRowKeys, record) => {
    if (selectedRowKeys.length > 0) {
      this.setState({
        selectedRowKeys: selectedRowKeys,
        sendButtonText: "И-мэйл илгээх (" + selectedRowKeys.length + ")",
        selectedVendors: [...record],
      });
    } else {
      this.setState({
        selectedRowKeys: selectedRowKeys,
        sendButtonText: "И-мэйл илгээх (" + selectedRowKeys.length + ")",
        selectedVendors: [],
      });
    }
  };

  fileOnChange = (info) => {
    this.setState({
      filelist: info.fileList,
      filedata: info.file,
      filename: info.file.name,
    });
  };
  sendEmail = () => {
    console.log(this.state.selectedVendors.length);
    if (this.state.selectedVendors.length > 0) {
      if (this.state.filename && this.state.filedata) {
        getBase64(this.state.filedata.originFileObj)
          .then((result) => {
            let filename = this.state.filename
              .split(".")
              .slice(0, -1)
              .join(".");
            let extension = this.state.filename.split(".").pop();
            let base64Data = result.split("base64,").pop();
            let vendors = [];
            this.state.selectedVendors.map((el) => {
              vendors = [...vendors, { email: el.vendoremail }];
            });
            let body = {
              vendors: vendors,
              attachment: {
                filename: filename,
                extension: extension,
                data: base64Data,
              },
              body: this.state.body,
              subject: this.state.subject,
              url: baseConfig.makurl,
              session_id: localStorage.getItem("access_token"),
            };
            API.post("sendEmail", body).then((response) => {
              if (response.status === 200 && response.data.retType === 0) {
                message.success("Амжилттай илгээгдлээ.");
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        message.warning("Файл хавсаргана уу.");
      }
    } else {
      message.warning("Нийлүүлэгч сонгоно уу.");
    }
  };

  onChangeBody = (value) => {
    this.setState({ body: value });
  };

  onChangeSubject = (value) => {
    this.setState({ subject: value });
  };

  render() {
    const columns = [
      {
        title: "Нэр",
        dataIndex: "vendorname",
        key: "vendorname",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <Button
              style={{ fontWeight: "500", color: "#0358A7" }}
              type="link"
              onClick={() =>
                this.showNewInputFormHandler(true, record.vendorid)
              }
            >
              {record.vendorname}
            </Button>
          );
        },
      },
      {
        title: "Регистр",
        dataIndex: "registernumber",
        key: "registernumber",
        width: "5%",
        align: "left",
      },
      {
        title: "Төрөл",
        dataIndex: "vendortypeid",
        key: "vendortypeid",
        width: "5%",
        align: "left",
        render: (text, record) => {
          return (
            <div>
              {record.vendortypeid === 1
                ? "ААН"
                : record.vendortypeid === 2
                ? "Хувь хүн"
                : "Гадаад"}
            </div>
          );
        },
      },
      {
        title: "Үйл ажиллагааны чиглэл",
        dataIndex: "activity",
        key: "activity",
        width: "15%",
        align: "left",
      },
      {
        title: "Компаний статус",
        dataIndex: "vendorstatusid",
        key: "vendorstatusid",
        width: "10%",
        align: "left",
        render: (text, record) => {
          return (
            <div>{record.vendortypeid === 1 ? "Идэвхитэй" : "Идэвхигүй"}</div>
          );
        },
      },
      {
        title: "Бүртгэсэн огноо",
        dataIndex: "created",
        key: "created",
        width: "10%",
        align: "left",
      },
      {
        title: "Ажилтан",
        dataIndex: "empname",
        key: "empname",
        width: "10%",
        align: "left",
      },
      {
        title: "Утасны дугаар",
        dataIndex: "empphone",
        key: "empphone",
        width: "7%",
        align: "left",
      },
      {
        title: "Байгууллагын и-мэйл",
        dataIndex: "vendoremail",
        key: "vendoremail",
        width: "12%",
        align: "left",
      },
      
    ];
    const { selectedRowKeys } = this.state;
    const rowSelection = {
      columnWidth: 40,
      selectedRowKeys,
      onChange: this.onSelectChange,
    };
    return (
      <div className="Container">
        <Row style={{ height: 56 }} justify="start" align="middle">
          <Col>
            <div className="HeaderLabel">Нийлүүлэгчийн жагсаалт</div>
          </Col>
          <Col>
            <div className="divider"></div>
          </Col>
          <Col>
            <ButtonLinkIcon
              icon={<SendMainIcon />}
              name={this.state.sendButtonText}
              onClick={() => {
                this.sendEmail();
              }}
            />
          </Col>
        </Row>
        <Row gutter={[16, 16]} style={{ marginBottom: 10 }}>
          <Col span={4}>
            <div className="Label">Гарчиг</div>
            <Input
              style={{ height: 30, width: "100%" }}
              size="large"
              defaultValue={this.state.subject}
              onChange={(e) => this.onChangeSubject(e.target.value)}
            />
          </Col>
          <Col span={8}>
            <div className="Label">Тайлбар</div>
            <Input
              style={{ height: 30, width: "100%" }}
              size="large"
              defaultValue={this.state.body}
              onChange={(e) => this.onChangeBody(e.target.value)}
            />
          </Col>
          <Col span={12}>
            <div className="Label">Файл хавсаргах</div>
            <Upload
              style={{ width: "100%" }}
              accept="*"
              openFileDialogOnClick
              onChange={this.fileOnChange}
              showUploadList={false}
              fileList={this.state.filelist}
            >
              <Button style={{ color: "black", borderColor: "#cecece" }}>
                <Row align="middle" justify="space-between">
                  <Col>{this.state.filename}</Col>
                  <Col style={{ marginLeft: 10, marginRight: 10 }}>
                    <UploadOutlined />
                  </Col>
                </Row>
              </Button>
            </Upload>
          </Col>
        </Row>

        <div id="vendor-list" style={{ marginRight: 15 }}>
          <Table
            dataSource={this.state.data}
            rowSelection={{ ...rowSelection, columnWidth: "2%" }}
            columns={[
              {
                title: "№",
                dataIndex: "key",
                key: "key",
                width: "3%",
                render: (text, row, index) => (
                  <>{this.state.data.indexOf(row) + 1}</>
                ),
              },
              ...columns,
            ]}
            pagination={false}
            rowKey="vendorid"
            scroll={{ y: 600 }}
          />
        </div>
        <Drawer
          title="Нийлүүлэгчийн дэлгэрэнгүй"
          width="1100px"
          placement="right"
          visible={this.state.showNewInputForm}
          onClose={() => this.showNewInputFormHandler(false, 0)}
          destroyOnClose={true}
        >
          <VendorInfo
            vendorid={this.state.selectedVendorId}
            showForm={this.showNewInputFormHandler}
          ></VendorInfo>
        </Drawer>
      </div>
    );
  }
}

export default withRouter(VendorList);
